import { render, staticRenderFns } from "./query_role.vue?vue&type=template&id=b9d74116&scoped=true&"
import script from "./query_role.vue?vue&type=script&lang=js&"
export * from "./query_role.vue?vue&type=script&lang=js&"
import style0 from "./query_role.vue?vue&type=style&index=0&id=b9d74116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d74116",
  null
  
)

export default component.exports